import { modalStore } from './store';
import type { ModalHandle, OpenModalOptions } from './types';

/**
 * Open a modal from anywhere — inside or outside React (event handlers, API interceptors,
 * store actions). Requires a mounted {@link ModalProvider}. Returns a handle whose `closed`
 * promise resolves with the outcome, so confirm/await flows read naturally:
 *
 * ```ts
 * const { action } = await openModal({ title: 'Delete?', actions: [...] }).closed;
 * ```
 */
export function openModal(options: OpenModalOptions): ModalHandle {
  return modalStore.open(options);
}

/** Close every open modal, top-first. */
export function closeAllModals(): void {
  modalStore.closeAll();
}
